import { render } from "./EventNotificationForm.vue?vue&type=template&id=488debec&scoped=true"
import script from "./EventNotificationForm.vue?vue&type=script&lang=js"
export * from "./EventNotificationForm.vue?vue&type=script&lang=js"

import "./EventNotificationForm.vue?vue&type=style&index=0&id=488debec&scoped=true&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488debec"]])

export default __exports__